<template>
  <ion-page>
    <ion-modal v-if="ModalOpen" ref="modal" :is-open="ModalOpen" :can-dismiss="canDismiss">
      <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start">
            <ion-button @click="closeModal">Cancel</ion-button>
          </ion-buttons>
          <ion-title>Request Estimate {{ RouteName }}</ion-title>
          <ion-buttons slot="end">
            <ion-button :strong="true" @click="">Submit</ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding">
        <ion-item lines="none">
          <div style="width:100%">
            <h3 style="margin-bottom: 10px;">Your Information</h3>
            <ion-input label="Enter your name" label-placement="stacked" v-model="quote.requestee.name" type="text"
              placeholder="Your name" autocomplete="name" style="margin-bottom: 10px;" required></ion-input>
            <ion-input label="Enter your Email (Company or Personal)" label-placement="stacked"
              v-model="quote.requestee.email" autocomplete="email" type="text" placeholder="Your Email"
              style="margin-bottom: 10px;" required></ion-input>
            <ion-input label="Enter your Phone Number " autocomplete="tel" label-placement="stacked"
              v-model="quote.requestee.phone" type="text" placeholder="Your Phone Number" style="margin-bottom: 10px;"
              required></ion-input>
            <h3 style="margin-bottom: 10px;">Your Company/Organization Information</h3>
            <ion-input label="Enter your Companies Name" label-placement="stacked"
              v-model="quote.requestee.company.name" type="text" placeholder="Company name" style="margin-bottom: 10px;"
              required></ion-input>
            <ion-input label="Enter your Companies Phone Number" label-placement="stacked"
              v-model="quote.requestee.company.phone" type="text" placeholder="Company Phone Number"
              style="margin-bottom: 10px;" required></ion-input>


            <h5 style="margin-bottom: 10px;">Your Company Address</h5>
            <ion-input label="Enter your Companies Address" label-placement="stacked"
              v-model="quote.requestee.company.address.addressLine1" type="text" placeholder="Address Line 1"
              style="margin-bottom: 10px;" required></ion-input>
            <ion-input label="Enter your Companies Address (Optional)" label-placement="stacked"
              v-model="quote.requestee.company.address.addressLine2" type="text" placeholder="Address Line 2 (Optional)"
              style="margin-bottom: 10px;"></ion-input>
            <ion-input label="Enter your Companies City" label-placement="stacked"
              v-model="quote.requestee.company.address.city" type="text" placeholder="City" style="margin-bottom: 10px;"
              required></ion-input>

            <ion-select label="Enter your Companies State" label-placement="stacked"
              v-model="quote.requestee.company.address.state" type="text" placeholder="State / Province / Region"
              style="margin-bottom: 10px;" required>
              <ion-select-option v-for="(state, i) in states" :key="i" :value="stateIds[i]">{{ state
              }}</ion-select-option>
            </ion-select>
            <ion-input label="Enter your Companies Zip Code" label-placement="stacked"
              v-model="quote.requestee.company.address.zip" type="text" placeholder="Zip / Postal Code"
              style="margin-bottom: 10px;" required></ion-input>

            <!-- Add more inputs here as needed, each will be on a new line -->
            <!-- Add more inputs here as needed, each will be on a new line -->
          </div>
        </ion-item>
        <ion-item>
          <div style="width:100%">
            <h3 style="margin-bottom: 10px;">Quote Information</h3>
            <ion-select label="The division you'd like a quote for" label-placement="stacked"
              v-model="quote.quote.division" type="text"
              :placeholder="'Your message or request' + $route.params.division" style="margin-bottom: 10px;" required>
              <ion-select-option value="div26">Division 26 Electrical Systems</ion-select-option>
              <ion-select-option value="div27">Division 27 Communications</ion-select-option>
              <ion-select-option value="div28">Division 28 Security Systems</ion-select-option>



            </ion-select>
            <ion-textarea label="Enter your message or request" label-placement="stacked" v-model="quote.quote.message"
              type="text" placeholder="Your message or request" style="margin-bottom: 10px;" :rows="6"
              required></ion-textarea>
          </div>
        </ion-item>
        <div>
          <ion-button style="justify-self: center;" size="large" form="modal" color="success"
            @click="submitForm()"><ion-icon :icon="outlines.send"></ion-icon> Submit Estimate Request</ion-button>
        </div>
      </ion-content>
    </ion-modal>
  </ion-page>
</template>
<script setup lang="ts">
import settings from "@/settings/email.json";
import { computed, ref, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  IonPage,
  IonIcon,
  IonHeader,
  IonFooter,
  IonToolbar,
  IonButtons,
  IonSelectOption,
  IonMenuButton,
  IonTextarea,
  IonModal,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonGrid,
  IonTitle,
  IonRow,
  IonCol,
  IonInput,
  IonToast,
  IonSelect,
  IonRadioGroup,
  IonRadio, toastController
} from "@ionic/vue";
const modal = ref<InstanceType<typeof IonModal> | null>(null);

var quote = ref({
  requestee: {
    name: "",
    email: "",
    phone: "",
    company: {
      name: "",
      phone: "",
      address: {
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        zip: ""
      }
    },
  },
  quote: {
    division: "",
    message: ""
  }
})
var ModalOpen = ref(false)
var RouteName = ref("")
var canDismiss = ref(false); // Allow modal to be dismissed
const route = useRoute();
const router = useRouter();

// Open modal when route matches
watch(
  () => route.fullPath,
  (newPath) => {
    if (newPath.startsWith("/requestquote")) {
      ModalOpen.value = true;
    } else {
      ModalOpen.value = false;
    }
  },
  { immediate: true }
);

onMounted(() => {
  // Only open modal if on the correct route
  if (route.fullPath.startsWith("/requestquote")) {
    ModalOpen.value = true;
  }
  canDismiss.value = false;
  const division = route.params.division;
  if (division) {
    quote.value.quote.division = division.toString();
  }
  switch (division) {
    case "div26":
      RouteName.value = "Division 26 Electrical"
      break;
    case "div27":
      RouteName.value = "Division 27 Communications"
      break;
    case "div28":
      RouteName.value = "Division 28 Security"
      break;
    default:
      RouteName.value = ""
  }
});
var allowedSites = [
  "https://aes-site-revamp.pages.dev",
  "https://www.aes-site-revamp.pages.dev",
  "https://aes-site-revamp.pages.dev",
  "http://localhost:5173"
];
console.log(router.options.history.state.back)

function back() {
  if (router.options.history.state.back) {
    for (const site of allowedSites) {
      if (router.options.history.state.back.toString().includes(site)) {
        // If the back URL is one of the allowed sites, navigate back
        router.push("/")
        return;
      }
    }

  }
  router.back();

}
async function submitForm() {
  console.log(quote.value)
  // Here you would typically send the quote data to your server or API
  // For demonstration, we'll just log it to the console
  let val = settings.estimateBody

  val = val.replace("%req.name%", quote.value.requestee.name)
  val = val.replace("%req.email%", quote.value.requestee.email)
  val = val.replace("%req.number%", quote.value.requestee.phone)

  val = val.replace("%comp.name%", quote.value.requestee.company.name)
  val = val.replace("%comp.number%", quote.value.requestee.company.phone)
  val = val.replace("%comp.address1%", quote.value.requestee.company.address.addressLine1)
  val = val.replace("%comp.address2%", quote.value.requestee.company.address.addressLine2)
  val = val.replace("%comp.city%", quote.value.requestee.company.address.city)
  val = val.replace("%comp.state%", quote.value.requestee.company.address.state)
  val = val.replace("%comp.zip%", quote.value.requestee.company.address.zip)

  val = val.replace("%quote.division%", quote.value.quote.division)
  val = val.replace("%quote.message%", quote.value.quote.message.replaceAll("\n","<br>"))

  val = val.replace("%def.datetime%", new Date().toLocaleString())




  let toastMessage = ""
  await sendEmail(settings.fromAddress, "jmeyer@aes-mlb.com", "Estimate for Division " + quote.value.quote.division.replace("div", "") + " " + quote.value.requestee.company.name, val).then((test) => {
    console.log("Email sent successfully");
    toastMessage = "Your estimate request has been submitted successfully! We will get back to you as soon as possible.";

  }).catch((error) => {
    console.error("Error sending email:", error);
    toastMessage = "There was an error submitting your estimate request. Please try again later.";
  });
  const toast = await toastController.create({
    message: toastMessage,
    duration: 1500,
    position: "bottom",

  });

  toast.present();
  back()
  ModalOpen.value = false; // Close the modal after submission
}
function closeModal() {
  ModalOpen.value = false;
  canDismiss.value = false;
  // Use nextTick to ensure modal is removed before navigating
  setTimeout(() => {
    back()
  }, 100);
}


</script>
<style></style>
<script lang="ts">
import * as outlines from 'ionicons/icons';
import router from "@/router";
import { stateIds, states } from "@/helper";
import { sendEmail } from "@/EmailHelper";

export default {
  name: 'Footer',
}
</script>